<template>
	<div class="celloger_mini_plus">
		<PageBanner></PageBanner>
		<div id="title" class="mini_title">
			<span class="mini_eng_title">Celloger Mini Plus</span> 全自动活细胞成像分析系统
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="mini_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">全自动活细胞成像分析系统</p>
			<p class="p2">Celloger Mini Plus</p>
			<p class="p3">Celloger Mini Plus是一款全自动活细胞成像分析系统，配备了最先进<br>
				的荧光/明场显微镜、自动聚焦和实时多位点成像技术。Mini Plus提供<br>
				了获得清晰图像和准确结果的多种工具，各种基于细胞的研究工作<br>
				和应用都可以用这个全方位的系统来完成。</p>
			<img src="../assets/img/production/Celloger Mini Plus.png" class="mini_img" />
		</div>
		<p class="exp3">Celloger Mini Plus是一款全自动活细胞成像分析系统，配备了最先进
			的荧光/明场显微镜、自动聚焦和实时多位点成像技术。Mini Plus提供
			了获得清晰图像和准确结果的多种工具，各种基于细胞的研究工作
			和应用都可以用这个全方位的系统来完成。</p>
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>

		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 3vh;">实时监测</p>
		<ul id="title" class="subtext" style="line-height: 40px;position: relative;">
			<li>无需将细胞样本从培养箱中拿出，消除了污染风险。</li>
			<li style="margin-top: 20px;">在湿热环境下保持设备的性能非常有挑战性，有了Celloger Mini Plus就<br class="br">
				可以非常轻松地不破坏细胞培养的最佳环境而长时间观察培养箱内的活细胞。</li>
		</ul>
		<div class="img_container12">
			<img src="../assets/img/production/12.png" class="img_12" />
		</div>
		<p id="title" class="maintext text_4">尺寸小巧</p>
		<ul id="title" class="subtext" style="line-height: 40px;position: relative;">
			<li>Celloger Mini Plus尺寸小巧，可以放进标准CO2培养箱。</li>
			<li style="margin-top: 20px;">设备重量约5kg，能够轻松地从培养箱中拿进拿出。</li>
		</ul>
		<div class="img_container13">
			<img src="../assets/img/production/13.png" class="img_13" />
		</div>
		<p id="title" class="maintext text_4">多点位成像</p>
		<p id="title" class="subtext" style="line-height: 40px;text-indent: 2em;">使用全自动镜头可以分别在X/Y轴移动117x 77mm，可以根据实验人员<br class="br">
			的设置（时间间隔、周期、总时长）在移动范围里获取多个位点的图像。</p>
		<div class="img_container14">
			<img src="../assets/img/production/14.png" class="img_14" />
		</div>
		<p id="title" class="maintext text_4" style="position: relative;">成像性能稳定</p>
		<p id="title" class="subtext" style="line-height: 40px;text-indent: 2em;">Celloger Mini Plus没有可移动载物台，而是依靠设备内的相机移动获取<br class="br">
			多位点的细胞图像。保证耗材和细胞样本都处于稳定的状态，为细胞生长<br class="br">
			提供了稳定的生长环境。</p>
		<div class="img_container15">
			<img src="../assets/img/production/15.png" class="img_15" />
		</div>
		<p id="title" class="maintext text_4">延时视频</p>
		<p id="title" class="subtext">根据设定的时间线拍摄图像并制作成视频。</p>
		<div class="img_container16">
			<img src="../assets/img/production/16.png" class="img_16" />
		</div>
		<p id="title" class="maintext text_4">用户友好的功能</p>
		<div class="img_container17">
			<img src="../assets/img/production/z轴.jpg" class="img_17" />
		</div>
		<div class="img_container17_1">
			<img src="../assets/img/production/自动聚焦.jpg" class="img_17_1" />
		</div>
		<div class="img_container17_2">
			<img src="../assets/img/production/软件包.jpg" class="img_17_2" />
		</div>

		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>

		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'CellogerMiniPlus',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".mini_container, .img_container12, .img_container13, .img_container14, .img_container15, .img_container16,	.img_container17, .img_container17_1, .img_container17_2"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 5vh;
	}

	.subtext {
		font-size: 18px;
	}

	.mini_container {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
		position: relative;
	}

	.y_img3 {
		margin-top: 20px;
		height: 450px;
		width: 1200px;
	}

	.mini_container p {
		position: absolute;
	}

	.mini_container .p1 {
		margin-right: 610px;
		margin-bottom: 230px;
		font-size: 28px;
	}

	.mini_container .p2 {
		margin-right: 525px;
		margin-bottom: 130px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.mini_container .p3 {
		margin-right: 400px;
		margin-top: 200px;
		font-size: 18px;
		line-height: 2;
	}

	.mini_img {
		position: absolute;
		width: auto;
		height: 340px;
		margin-left: 660px;
	}

	.img_12 {
		width: 340px;
	}

	.img_12, .img_13 {
		height: 390px;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 10vh;
	}

	.img_13 {
		width: 540px;
	}

	.img_14 {
		width: 540px;
		height: 390px;
		position: absolute;
		margin-left: 50vw;
	}

	.img_15 {
		width: 420px;
		height: 280px;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 20vh;
	}

	.img_16 {
		width: 445px;
		height: 310px;
		float: right;
		position: absolute;
		margin-left: 50vw;
	}

	.img_17, .img_17_1, .img_17_2 {
		width: 1125px;
		height: 363px;
	}

	.img_container12, .img_container13, .img_container14, .img_container15, .img_container16, .img_container17, .img_container17_1, .img_container17_2 {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.mini_title {
		font-size: 1.8em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.mini_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.exp3 {
		display: none;
	}

	.text_4 {
		margin-top: 30vh;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.mini_container .p1 {
			margin-right: 490px;
			font-size: 1.5rem;
		}

		.mini_container .p2 {
			margin-right: 500px;
			font-size: 2rem;
		}

		.mini_container .p3 {
			margin-right: 280px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.mini_img {
			position: absolute;
			width: auto;
			height: 240px;
			margin-left: 560px;
		}

		.img_12 {
			width: 290px;
			height: 340px;
			margin-left: 700px;
		}

		.img_13 {
			width: 440px;
			height: 300px;
		}

		.img_14 {
			width: 440px;
			height: 300px;
			margin-left: 700px;
		}

		.img_15 {
			width: 370px;
			height: 230px;
			margin-left: 650px;
			margin-bottom: 20vh;
		}

		.img_17, .img_17_1, .img_17_2 {
			width: 900px;
			height: 300px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.mini_title {
			font-size: 1rem;
			margin-top: 5vh;
		}

		.mini_eng_title {
			font-size: 1rem;
			margin-bottom: 5.2rem;
			letter-spacing: 1px;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.mini_container .p1 {
			font-size: 1.1rem;
			margin-right: 160px;
			margin-top: 180px;
		}

		.mini_container .p2 {
			font-size: 1.1rem;
			margin-right: 200px;
			margin-top: 180px;
		}

		.mini_container .p3 {
			display: none;
		}

		.mini_img {
			height: 140px;
			width: auto;
			margin-top: 20px;
			margin-left: 220px;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.banner3 {
			margin-top: 2vh;
			width: 100%;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_12 {
			width: 360px;
		}

		.img_12, .img_13 {
			height: auto;
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.img_13 {
			width: 400px;
		}

		.img_14, .img_15 {
			width: 380px;
			height: auto;
			position: relative;
			margin-left: 0;
		}

		.img_15 {
			margin-bottom: 0;
		}

		.img_16 {
			width: 380px;
			height: auto;
			position: relative;
			margin-left: 0;
		}

		.img_17, .img_17_1, .img_17_2 {
			width: 420px;
			height: auto;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		.br {
			display: none;
		}

		.text_4 {
			margin-top: 100px;
		}
	}
</style>